// styles
import styles from "./primaryButton.module.scss";

import classNames from "classnames";
import React, { useEffect, useState } from "react";

// todo improve this with
export enum PrimaryButtonType {
  DEFAULT = "DEFAULT",
  PRIMARY_DARK = "PRIMARY_DARK",
  PRIMARY_LIGHT = "PRIMARY_LIGHT",
  DISABLED = "DISABLED",
  DISABLED_DARK = "DISABLED_DARK",
  DANGER = "DANGER",
  ABSHER = "ABSHER",
  ROUNDED = "ROUNDED",
}

export enum PrimaryButtonSize {
  SMALL = "small",
  MEDIUM = "medium",
  REGULAR = "regular",
  LARGE = "large",
}

export interface PrimaryButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  Lefticon?: React.ReactNode;
  Righticon?: React.ReactNode;
  buttonType?: PrimaryButtonType;
  size?: PrimaryButtonSize;
  backgroundColor?: string;
  width?: string;
  disableRipple?: boolean;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  Lefticon,
  Righticon,
  buttonType = PrimaryButtonType.DEFAULT,
  size = PrimaryButtonSize["LARGE"],
  backgroundColor,
  width,
  disableRipple = false,
  children,
  ...props
}: PrimaryButtonProps): JSX.Element => {
  const [buttonStyle, setButtonStyle] = useState<PrimaryButtonType>(
    PrimaryButtonType.DEFAULT
  );

  const [coords, setCoords] = useState({ x: -1, y: -1 });
  const [isRippling, setIsRippling] = useState(false);

  useEffect(() => {
    if (coords.x !== -1 && coords.y !== -1) {
      setIsRippling(true);
      setTimeout(() => setIsRippling(false), 300);
    } else setIsRippling(false);
  }, [coords]);

  useEffect(() => {
    if (!isRippling) setCoords({ x: -1, y: -1 });
  }, [isRippling]);

  useEffect(() => {
    if (props.disabled && buttonType !== PrimaryButtonType.DISABLED_DARK) {
      setButtonStyle(PrimaryButtonType.DISABLED);
    } else {
      setButtonStyle(buttonType);
    }
  }, [buttonType, props.disabled]);

  return (
    <button
      className={classNames(
        styles[`primary_button`],
        buttonStyle === PrimaryButtonType.DEFAULT &&
          styles["primary_button_default"],
        buttonStyle === PrimaryButtonType.PRIMARY_DARK &&
          styles["primary_button_primary_dark"],
        buttonStyle === PrimaryButtonType.PRIMARY_LIGHT &&
          styles["primary_button_primary_light"],
        buttonStyle === PrimaryButtonType.DISABLED &&
          styles["primary_button_disabled"],
        buttonStyle === PrimaryButtonType.DISABLED_DARK &&
          styles["primary_button_disabled_dark"],
        buttonStyle === PrimaryButtonType.DANGER &&
          styles["primary_button_danger"],
        buttonStyle === PrimaryButtonType.ABSHER &&
          styles["primary_button_absher"],
        buttonStyle === PrimaryButtonType.ROUNDED &&
          styles["primary_button_rounded"],
        styles[`primary_button_${size}`]
      )}
      style={{ backgroundColor: backgroundColor || "", width: width || "100%" }}
      onClick={(e) => {
        if (!disableRipple) {
          const node = e.target as HTMLElement;
          const rect = node.getBoundingClientRect();
          setCoords({ x: e.clientX - rect.left, y: e.clientY - rect.top });
        }
        props.onClick && props.onClick(e);
      }}
      {...props}>
      {isRippling ? (
        <span
          className={styles["ripple"]}
          style={{
            left: coords.x,
            top: coords.y,
          }}
        />
      ) : (
        ""
      )}
      <span>{Lefticon ? Lefticon : ""}</span>
      {children}
      <span>{Righticon ? Righticon : ""}</span>
    </button>
  );
};

export default PrimaryButton;
